import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Crown } from 'lucide-react';
import { membership } from '../data/plansData';

const Navigation = ({ onScrollToMembership, onScrollToQuiz, onScrollToSpaces }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Membership', action: onScrollToMembership },
    { label: 'Espaços', action: onScrollToSpaces },
    { label: 'Quiz', action: onScrollToQuiz },
    { label: 'Eventos', href: '#events' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'bg-transparent py-5'
      }`}
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <motion.a
          href="/"
          className="flex items-center gap-2 group"
          whileHover={{ scale: 1.02 }}
          data-testid="logo"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/1kp6ef16_aibrasil_logo.png" 
            alt="AI Brasil" 
            className="h-12 w-auto"
          />
        </motion.a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link, index) => (
            <motion.a
              key={link.label}
              href={link.href || '#'}
              onClick={(e) => {
                if (link.action) {
                  e.preventDefault();
                  link.action();
                }
              }}
              className="text-white/80 hover:text-neon-green transition-colors font-medium text-sm tracking-wide"
              whileHover={{ y: -2 }}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              {link.label}
            </motion.a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <motion.a
            href="https://ai.eco.br/sign_in"
            className="text-white/80 hover:text-white transition-colors font-medium text-sm"
            whileHover={{ scale: 1.05 }}
          >
            Entrar
          </motion.a>
          <motion.a
            href={membership.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="relative overflow-hidden px-6 py-2.5 bg-neon-green text-black font-bold rounded-full text-sm flex items-center gap-1.5"
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(0, 255, 0, 0.5)' }}
            whileTap={{ scale: 0.95 }}
            data-testid="nav-cta-button"
          >
            <Crown className="w-4 h-4" />
            Ser Membro
          </motion.a>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          data-testid="mobile-menu-button"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden glass border-t border-white/10"
          >
            <nav className="flex flex-col p-6 gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href || '#'}
                  onClick={(e) => {
                    if (link.action) {
                      e.preventDefault();
                      link.action();
                    }
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-white/80 hover:text-neon-green transition-colors font-medium py-2"
                >
                  {link.label}
                </a>
              ))}
              <div className="flex flex-col gap-3 pt-4 border-t border-white/10">
                <a
                  href="https://ai.eco.br/sign_in"
                  className="text-center text-white/80 hover:text-white transition-colors font-medium py-2"
                >
                  Entrar
                </a>
                <a
                  href={membership.ctaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-neon-green text-black font-bold rounded-full"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <Crown className="w-4 h-4" />
                  Ser Membro
                </a>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navigation;
